import { getRegion } from '../components/regionWrapper';
import Cookies from 'js-cookie';
import { Region } from '../utils/commonInterfaces';
import { getExportAxiosRequestByRegion } from '../utils/getExportAxiosRequestByRegion';

export const patchApi = (api: string, info: any) => {
    const region = getRegion();
    const axios = getExportAxiosRequestByRegion(region as Region);
    return async (_dispatch: any) => {
        try {
            if (region === Region.EG) {
                const token = Cookies.get('token');
                const { data } = await axios(api, {
                    data: info,
                    method: 'PATCH',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                return {
                    payload: data
                };
            } else {
                const { data } = await axios(api, {
                    data: info,
                    method: 'PATCH',
                    headers: {
                        // Authorization header removed - backend reads from cookie
                    },
                    withCredentials: true // Important - enables automatic cookie transmission
                });
                return {
                    payload: data
                };
            }
        } catch (e) {
            return {
                error: true,
            };
        }
    }
}